module.exports = __webpack_public_path__ + "img/code-js-xl.7b0f6957.webp";